import $ from 'jquery';
import Truncate from '../ui/truncate';
import '../app-extends/wishlist-plus/product-card';
import '../../styles/templates/collection.scss';

/**
 * Truncations
 */
$('.truncation').each((_, item) => {
  new Truncate(item);
});

class QuickBuyButton extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('click', this.handleClick.bind(this))
  }

  handleClick(e) {
    e.stopPropagation()
    const index = this.dataset.index
    const targetForm = document.querySelector(`quick-buy-form[data-index="${index}"]`)
    
    if (targetForm) {
      // Close any open forms first
      document.querySelectorAll('quick-buy-form.active').forEach(form => {
        form.classList.remove('active')
      })
      targetForm.classList.add('active')
      document.body.classList.add('popup-active')
    }
  }
}

class QuickBuyForm extends HTMLElement {
  constructor() {
    super()
    this.form = this.querySelector('form')
    this.addToCart = this.querySelector('[data-add-to-cart]')
    this.form?.addEventListener('submit', this.addProduct.bind(this))
    this.atcBtnText = this.querySelector('[data-add-to-cart-text]')
    this.cartCount = document.querySelector('[data-cart]')
    this.closeBtn = this.querySelector('.close-btn')
    
    // Bind close button if it exists
    this.closeBtn?.addEventListener('click', (e) => {
      e.stopPropagation()
      this.close()
    })

    // Close when clicking outside
    document.addEventListener('click', (e) => {
      if (document.body.classList.contains('popup-active')) {
        const isClickInsideForm = this.contains(e.target) && !e.target.classList.contains('quick-buy-form')
        const isQuickBuyButton = e.target.closest('quick-buy-button')
        
        if (!isClickInsideForm && !isQuickBuyButton) {
          this.close()
        }
      }
    })
  }

  addProduct(event) {
    event.preventDefault()

    const productId = this.querySelector('[name="id"]').value
    const body = {
      items: [
        {
          id: productId,
          quantity: 1
        },
      ],
    };
    this.setButtonLabel('adding');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.afterCartUpdate()
        this.setButtonLabel('added')
      })
      .catch((error) => {
        console.error('Error adding to cart:', error)
        this.setButtonLabel('error')
      });
  }

  afterCartUpdate() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((data) => {
        this.cartCount.querySelector('.cart__count').innerHTML = data.item_count
        this.cartCount.classList.add('has-updated')
        setTimeout(() => {
          this.cartCount.classList.remove('has-updated')
          this.setButtonLabel()
        }, 1500)

        setTimeout(() => {
          this.close()
        }, 2500)
      })
      .catch((error) => {
        console.error('Error updating cart:', error)
        this.setButtonLabel('error')
      })
  }

  setButtonLabel(state = "default") {
    let label = ''
    switch(state) {
      case 'adding':
        label = theme.strings.quickAdd.addingToCart
        break
    
      case 'added':
        label = theme.strings.quickAdd.addedToCart
        break

      case 'error':
        label = theme.strings.quickAdd.error || 'Error'
        break

      default:
        label = theme.strings.quickAdd.addToCart
    }
    this.atcBtnText.innerHTML = label
  }

  close() {
    this.classList.remove('active')
    document.body.classList.remove('popup-active')
  }
}

class ProductCardForm extends HTMLElement {
  constructor() {
    super()
    this.form = this.querySelector('form')
    this.addToCart = this.querySelector('[data-add-to-cart]')
    this.form?.addEventListener('submit', this.addProduct.bind(this))
    this.atcBtnText = this.querySelector('[data-add-to-cart-text]')
    this.cartCount = document.querySelector('[data-cart]')
  }

  addProduct(event) {
    event.stopPropagation()
    event.preventDefault()

    const productId = this.querySelector('[name="id"]').value
    const body = {
      items: [
        {
          id: productId,
          quantity: 1
        },
      ],
    };
    this.setButtonLabel('adding');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.afterCartUpdate()
        this.setButtonLabel('added')
      })
      .catch((error) => {
        console.error('Error adding to cart:', error)
        this.setButtonLabel('error')
      });
  }

  afterCartUpdate() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((data) => {
        this.cartCount.querySelector('.cart__count').innerHTML = data.item_count
        this.cartCount.classList.add('has-updated')
        setTimeout(() => {
          this.cartCount.classList.remove('has-updated')
          this.setButtonLabel()
        }, 1500)

        setTimeout(() => {
          this.close()
        }, 2500)
      })
      .catch((error) => {
        console.error('Error updating cart:', error)
        this.setButtonLabel('error')
      })
  }

  setButtonLabel(state = "default") {
    let label = ''
    switch(state) {
      case 'adding':
        label = theme.strings.quickAdd.addingToCart
        break
    
      case 'added':
        label = theme.strings.quickAdd.addedToCart
        break

      case 'error':
        label = theme.strings.quickAdd.error || 'Error'
        break

      default:
        label = theme.strings.quickAdd.addToCart
    }
    this.atcBtnText.innerHTML = label
  }

  close() {
    this.classList.remove('active')
    document.body.classList.remove('popup-active')
  }
}

// Register custom elements
customElements.define('quick-buy-button', QuickBuyButton)
customElements.define('quick-buy-form', QuickBuyForm)
customElements.define('product-card-form', ProductCardForm)
